/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  baseAPI: 'https://api.servicekiosk.com.au',
  redirectUri: 'https://admin.servicekiosk.com.au/auth/reset-password',
  customerFacingURL: 'https://www.servicekiosk.com.au',
//   defaultEntity: 4,
  discount: 0.1,
  serviceType: [
    { id: 1, description: "Express", code: "express" },
    { id: 2, description: "LogBook ", code: "logbook" },
    { id: 7, description: "Premium ", code: "premium" },
    { id: 8, description: "Premium Plus ", code: "premium-plus" },
  ],
  citiesOfStates: {
    'NSW': 'Sydney',
    'ACT': 'Canberra',
    'VIC': 'Melbourne',
    'QLD': 'Brisbane',
    'SA': 'Adelaide',
    'WA': 'Perth',
    'TAS': 'Hobart',
    'NT': 'Darwin'
  },
  percentDiscount: 0.1,
  cardPaymentFee: 0.0093,
  defaultTimezone: 'Australia/Brisbane',
  version: "20250121.1001",
};
